module.exports = __webpack_public_path__ + "google-maps-icon.ba000e7f.png";


//////////////////
// WEBPACK FOOTER
// ../statics/assets/img/google-maps-icon.png
// module id = 2453
// module chunks = 1